import { ApiPartnerEnum } from '@claas-rdv/rdv-client';

/**
 * Type guard to check if a string is a valid ApiPartnerEnum value.
 *
 * - `SOFF` → Okta  (Händler / Dealer)
 * - `CC3`  → Auth0 (Kunden / Customer)
 */
export function isApiPartner(value: string): value is ApiPartnerEnum {
  return value === ApiPartnerEnum.SOFF || value === ApiPartnerEnum.CC3;
}
